import React, { createContext, useState } from 'react'
import PropTypes from 'prop-types'
import { SubPageBreadCrumbs } from 'Components/BreadCrumbs'
import { useParams } from 'react-router-dom'
import { DataTable, Menu } from './components'
import { useSubscription } from '@apollo/client'
import { SUB_BUYER } from 'Util/subscriptions'
import leadingZeroes from 'leading-zeroes';
import { appConstant } from 'Util/constants'
import _ from 'lodash'

/** Page context */
export const CRMWholesaleContext = createContext()

const CRMWholeSalePage = props => {
    const params = useParams();
    const [pageState, setPageState] = useState({
        selectedUser: {}
    })

    /** status condition */
    const status = !_.isUndefined(params.status) ? { _eq: params.status } : {}

    const { data, loading, error } = useSubscription(SUB_BUYER, {
        variables: {
            where: {
                status
                // deleted_at: { _is_null: true }
            }
        }
    });

    const formatData = (data) => {
        if (loading) return [];
        // console.log('data', data);
        return data?.buyer_db?.buyer_users || [];
      };
      

    return (
        <CRMWholesaleContext.Provider value={{ pageState, setPageState }}>
            <SubPageBreadCrumbs />
            <Menu />
            <DataTable
                data={loading ? [] : formatData(data)}
                loading={loading}
                pageSize={50}
                height={500}
                onSelectRow={(rec) => { setPageState({ ...pageState, selectedUser: rec }) }}
            />
        </CRMWholesaleContext.Provider>
    )
}

CRMWholeSalePage.propTypes = {}

export default CRMWholeSalePage